/**
 * This is default modal class with a11y functions
 * Please fee free to update this class directly or inherit from it
 */
import { addModalKeyDownHandler } from "../utils/a11y";
import Vimeo from "@vimeo/player";
import YouTubePlayer from "youtube-player";
import { getYoutubeID } from "../utils/utils";
import { gsap } from "gsap";

export default class Modal {
  constructor(elem, APP) {
    this.elem = elem;
    this.openBtn = this.elem;
    this.modal = document.querySelector(".js-vmodal");
    this.dialog = document.querySelector(".js-vmodal-dialog");
    this.closeBtn = document.querySelector(".js-btn-vmodal-close");
    this.cancelBtn = document.querySelector(".js-btn-vmodal-cancel");
    this.okBtn = document.querySelector(".js-btn-vmodal-ok");
    this.firstFocusableElement = this.closeBtn;
    this.lastFocusableElement = this.okBtn;
    this.playerContainer = document.querySelector(".js-vmodal-player");
    this.videoDom;
    this.videoObj;
    this.background = document.querySelector(".js-vmodal-background");
  }

  addMP4(_url) {
    this.videoDom = document.createElement("div");
    this.videoDom.classList.add("vmodal-mp4");

    this.videoDom.innerHTML = `<video playsinline controls autoplay>
      <source src="${_url}" type="video/mp4">
    </video>`;

    this.playerContainer.append(this.videoDom);
  }

  addVimeo(_url) {
    this.videoDom = document.createElement("div");
    this.videoDom.classList.add("vmodal-vimeo");
    this.playerContainer.append(this.videoDom);

    this.videoObj = new Vimeo(this.videoDom, {
      url: _url,
      autoplay: true,
      loop: false,
      color: "0032ff",
      pip: false,
      title: false,
      byline: false,
      portrait: false,
      playsinline: true,
      autopause: true,
      controls: true,
      muted: false,
      // responsive: true,
    });
  }

  addYoutube(_url) {
    this.videoDom = document.createElement("div");
    this.videoDom.classList.add("vmodal-youtube");
    this.youtubeIframe = document.createElement("div");
    this.videoDom.append(this.youtubeIframe);
    this.playerContainer.append(this.videoDom);

    this.videoObj = YouTubePlayer(this.youtubeIframe, {
      width: "100%",
      playsinline: 1,
      playerVars: {
        autoplay: 1,
        controls: 1,
      },
    });

    this.videoObj.cueVideoById(getYoutubeID(_url));
  }

  addVideo() {
    if (this.elem.dataset.type == "mp4") {
      this.addMP4(this.elem.dataset.url);
    } else if (this.elem.dataset.type == "vimeo") {
      this.addVimeo(this.elem.dataset.url);
    } else if (this.elem.dataset.type == "youtube") {
      this.addYoutube(this.elem.dataset.url);
    }
  }

  removeVideo() {
    if (this.videoDom) {
      this.videoDom.remove();
      window.dispatchEvent(new Event("VideoModalDisabled"));
    }

    this.videoObj = null;
  }

  openModal(xPos = 0, yPos = 0) {
    this.modal.classList.add("is-visible");
    // this.closeBtn.focus();
    setTimeout(() => {
      this.background.style.left = `${xPos}px`;
      this.background.style.top = `${yPos}px`;

      const w = window.innerWidth;
      var tl = gsap.timeline({});
      tl.fromTo(
        this.background,
        {
          scaleX: 1,
          scaleY: 1,
          width: 10,
          height: 10,
          backgroundColor: "#0032ff",
          duration: 0.1,
          borderRadius: '100%',
        },
        {
          scaleX: w + 500,
          scaleY: w + 500,
          duration: 1,
          borderRadius: '100%',
          ease: "power2.in",
        }
      );
      tl.to(this.background, {
        left: window.innerWidth / 2,
        top: window.innerHeight / 2,
        scaleX: window.innerWidth + 5,
        scaleY: window.innerHeight + 5,
        borderRadius: '0px',
        backgroundColor: "#000",
        duration: 0.2,
        ease: "none",
      });
      // tl.to(this.background, {
      //   backgroundColor: "#000",
      //   duration: 0.1,
      // });
    }, 100);

    setTimeout(() => {
      this.playerContainer.classList.add("enabled");
    }, 1300);

    this.addVideo();
    document.body.classList.add("lock");
    window.dispatchEvent(new Event("VideoModalEnabled"));
  }

  closeModal() {
    this.removeVideo();
    this.modal.classList.remove("is-visible");
    this.playerContainer.classList.remove("enabled");
    document.body.classList.remove("lock");
    // this.openBtn.focus();

    this.background.style.transform = "scale(0, 0)";
    this.background.style.top = "0";
    this.background.style.left = "0";
    this.background.style.width = "1px";
    this.background.style.height = "1px";
    this.background.style.borderRadius = "50%";
    this.background.style.backgroundColor = "#0032ff";
  }

  resizeHandler() {
    if (this.modal.classList.contains("is-visible")) {
      this.background.style.transform = `scale(${window.innerWidth + 5}, ${
        window.innerHeight + 5
      })`;

      this.background.style.left = `${window.innerWidth / 2}px`;
      this.background.style.top = `${window.innerHeight / 2}px`;
    }
  }

  init() {
    addModalKeyDownHandler(
      this.dialog,
      this.firstFocusableElement,
      this.lastFocusableElement
    );

    this.openBtn.addEventListener("click", (e) => {
      // prevent bubble up
      e.stopPropagation();
      let cr = this.elem.getBoundingClientRect();
      this.openModal(cr.left, cr.top);

      // this.openModal(e.clientX, e.clientY);
    });

    this.closeBtn.addEventListener("click", (e) => {
      this.closeModal();
    });

    window.addEventListener("resize", () => {
      this.resizeHandler();
    });

    // this.cancelBtn.addEventListener("click", () => {
    //   this.closeModal();
    // });

    // this.okBtn.addEventListener("click", () => {
    //   this.closeModal();
    // });

    // this.modal.addEventListener("click", (e) => {
    //   if (!this.dialog.contains(e.target)) {
    //     this.closeModal();
    //   }
    // });
  }
}
